import { render, staticRenderFns } from "./SLADoc.vue?vue&type=template&id=44b2ddc0&scoped=true&"
import script from "./SLADoc.vue?vue&type=script&lang=js&"
export * from "./SLADoc.vue?vue&type=script&lang=js&"
import style0 from "./SLADoc.vue?vue&type=style&index=0&id=44b2ddc0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44b2ddc0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/oeze/Documents/grupa/grupa-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('44b2ddc0')) {
      api.createRecord('44b2ddc0', component.options)
    } else {
      api.reload('44b2ddc0', component.options)
    }
    module.hot.accept("./SLADoc.vue?vue&type=template&id=44b2ddc0&scoped=true&", function () {
      api.rerender('44b2ddc0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/SLADoc.vue"
export default component.exports